var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.656 14.856a3.098 3.098 0 0 0-4.282.007l-1.464 1.165c-3.198-1.357-5.474-3.638-6.932-6.947l1.159-1.456a3.1 3.1 0 0 0 .006-4.281S7.291.937 7.26.906C6.054-.302 4.088-.301 2.933.859L1.784 1.862C.634 3.012 0 4.565 0 6.238 0 13.874 10.126 24 17.762 24a6.152 6.152 0 0 0 4.421-1.833l.912-1.05a3.1 3.1 0 0 0 0-4.376c-.03-.031-2.438-1.883-2.438-1.883Zm.977 4.896-.912 1.05c-.771.772-1.821 1.197-2.959 1.197C11.773 21.999 2 13.194 2 6.237c0-1.138.425-2.189 1.146-2.913l1.15-1.005a1.095 1.095 0 0 1 1.509-.037s1.842 2.393 1.872 2.423a1.095 1.095 0 0 1 0 1.549c-.027.027-1.635 2.044-1.635 2.044a1 1 0 0 0-.146.995c1.713 4.268 4.681 7.232 8.821 8.812.328.126.702.068.979-.151 0 0 2.018-1.608 2.044-1.635a1.121 1.121 0 0 1 1.549 0c.03.031 2.425 1.873 2.425 1.873.388.43.374 1.097-.085 1.56ZM23.121.879A2.976 2.976 0 0 0 21 0h-4a3.006 3.006 0 0 0-3 3.001v6.621c.003.515.287.983.744 1.221.195.102.406.153.621.153.289 0 .586-.094.86-.286L18.352 9h2.647c1.654 0 3-1.346 3-3V3c0-.802-.313-1.555-.879-2.122ZM22 6c0 .551-.448 1-1 1h-3a1 1 0 0 0-.627.221l-1.372 1.105V3.002a1 1 0 0 1 .999-1h4a.998.998 0 0 1 1 1v3Z",
    fill: "#5671f1",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.20cde8a31b198698c10a00c485802707.svg";
export { ForwardRef as ReactComponent };